export class SavedOrderData{
    constructor(orderNumber, isNumberFromSite, customerReference, chassisNumber, steeringGeomRequired) {
        this.orderNumber = orderNumber;
        this.isNumberFromSite = isNumberFromSite;
        this.customerReference = customerReference;
        this.chassisNumber = chassisNumber;
        this.steeringGeomRequired = steeringGeomRequired;
    }
  }